/**
 * Query param poblaciones: nombres INE con coma («Ràfol d'Almúnia, el»).
 * Separador canónico `|` (no partir por coma).
 */
export const POBLACIONES_QUERY_SEP = "|";

export function joinPoblacionesQueryParam(list) {
  return (list || [])
    .map((x) => String(x).trim())
    .filter(Boolean)
    .join(POBLACIONES_QUERY_SEP);
}
